import clsx from 'clsx';
import { ReactElement, ReactNode } from 'react';

interface DrawerFooterProps {
  className?: string;
  noDivider?: boolean;
  children?: ReactNode;
  testId?: string;
}

/**
 * DrawerFooter can be used to add a themed footer to the Drawer.
 */
export function DrawerFooter({
  className,
  noDivider,
  children,
  testId,
}: Readonly<DrawerFooterProps>): ReactElement<DrawerFooterProps> {
  return (
    <div data-testid={testId ?? undefined} className={clsx('p-6 pt-2', className)}>
      {!noDivider && <hr className="border-divider -mx-2 mb-4 mt-0 border-0 border-b" />}
      {children}
    </div>
  );
}
